/**
 * Interface for the actions types in the basket header
 */
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';

import { CBasketConfigurationKeys } from '../model';

export enum IBasketActionTypes {
  BASKET_MANAGER = 'basketManager',
  CLEAR_BASKET = 'clearBasket',
  COPY_BASKET = 'copyBasket',
  CREATE_COMMERCIAL_LIST = 'createCommercialList',
  DOWNLOAD_CONTENT = 'downloadContent',
  DOWNLOAD_CONTENT_H2 = 'downloadContentH2',
  DOWNLOAD_PDF_ASYNC = 'downloadPdfAsync',
  DROP_SHIP = 'dropShip',
  EDIT_ADDRESSES = 'editAddresses',
  EMAIL_BASKET = 'emailBasket',
  SEND_PDF_CONFIRMATION = 'sendPdfConfirmation',
  SWITCH_BASKET = 'switchBasket',
  UPLOAD_MDO_BASKET = 'uploadMDOBasket',
  CLEAR_MANUAL_DISCOUNTS = 'clearManualDiscounts',
}

/**
 * Interface for the actions types in the basket header
 */
export enum IBasketBulkActionTypes {
  DELETE_BASKET = 'deleteBasket',
}

interface IGenericAction {
  /* Action optional icon */
  icon?: IconDefinition;

  /* Action display name */
  displayName: string;
}

/**
 * Interface for the actions in the basket header
 */
export interface IBasketAction extends IGenericAction {
  /* Action type to handle */
  actionType: IBasketActionTypes;
}
/**
 * Interface for the actions in the basket header
 */
export interface IBasketBulkAction extends IGenericAction {
  /* Action type to handle */
  actionType: IBasketBulkActionTypes;
}

export enum IAddressLineActions {
  COPY_PRODUCTS = 'COPY_PRODUCTS',
}

export type IAddressLineActionRules =
  CBasketConfigurationKeys.CopyProductsEnabled;

export type IAddressActionRulesMap = Record<
  IAddressLineActions,
  IAddressLineActionRules
>;
